import React from "react";
import { Link } from "react-router-dom";
import { Phone, CalendarHeart, MessageCircle } from "lucide-react";
import { tel } from "@/data/site";
import { useContent } from "@/context/ContentContext";

export default function MobileCTA() {
  const CLINIC = useContent();
  return (
    <div
      data-testid="mobile-cta-bar"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-soft-border bg-cream/95 backdrop-blur-md lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a href={tel(CLINIC.appointmentMobile)} data-testid="cta-call" className="flex flex-col items-center gap-1 py-3 text-charcoal">
        <Phone className="h-5 w-5 text-terracotta" />
        <span className="text-[0.7rem] font-medium">Call Clinic</span>
      </a>
      <a
        href={`https://wa.me/${CLINIC.whatsappDigits}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="cta-whatsapp"
        className="flex flex-col items-center gap-1 border-x border-soft-border py-3 text-charcoal"
      >
        <MessageCircle className="h-5 w-5 text-terracotta" />
        <span className="text-[0.7rem] font-medium">WhatsApp</span>
      </a>
      <Link to="/appointment" data-testid="cta-book" className="flex flex-col items-center gap-1 bg-terracotta py-3 text-cream">
        <CalendarHeart className="h-5 w-5" />
        <span className="text-[0.7rem] font-semibold">Book Now</span>
      </Link>
    </div>
  );
}
